import React, { Component } from 'react'
import "../../../../css/general-style.css"
import '../../../../css/table-responsive.css'
import '../../../PreSaleOrdersList.css'
import { NumberFormat } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai'
import PieGraph from '../../../../components/PieGraph';
import DashModalV2 from '../../../../components/DashModalV2';
import { getValueCookie } from '../../../../services/cookieService';

// Goal-completion color per row (2026-09-09 redesign) — same thresholds/colors
// CLAUDE.md's table row-coding rule already used (grayTableCell/yellowTableCell/
// greenTableCell class names came from Class.js, kept as-is there), just mapped
// to a left-border accent on the card instead of a table row background.
function statusColor(colorClass) {
    if (colorClass === 'grayTableCell') return '#EF4444'   // <30% of goal
    if (colorClass === 'yellowTableCell') return '#F59E0B' // 30-99% of goal
    return '#10b981'                                       // >=100% of goal
}

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        Title: '',
        showModal1: false,
        Detail: [],
        Total: 0

    }
    clearStates() {
        this.setState({
            Detail: [],
            Title: '',
            Total: 0
        })
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
        this.clearStates()
    }
    getTotals() {
        let total = 0
        for (const row of this.state.Detail) {
            total += Number(row.NonTaxableSalesAmt) || 0
        }
        this.setState({ Total: total })
    }

    async getDetail(detail, title) {
        const arr = Array.isArray(detail) ? detail : []
        const sorted = arr.slice().sort((a, b) => (Number(b.NonTaxableSalesAmt) || 0) - (Number(a.NonTaxableSalesAmt) || 0))
        const MAX = 500
        const limited = sorted.length > MAX ? sorted.slice(0, MAX) : sorted
        const fullTotal = arr.reduce((s, r) => s + (Number(r.NonTaxableSalesAmt) || 0), 0)
        const titleSuffix = sorted.length > MAX ? ` (top ${MAX} of ${sorted.length})` : ''
        await this.setState({ Detail: limited, Title: title + titleSuffix, Total: fullTotal })
        await this.handleModalOpen("showModal1")
    }
    addMonth() {
        if (getValueCookie('TypeUser') === '1') {
            // Create a NEW Date to avoid mutating the parent's state object directly
            const next = new Date(this.props.Date.getTime());
            next.setMonth(next.getMonth() + 1);
            this.props.Father.changeAllMonthData(this.props.SalesPerson, next.getTime());
        }
    }
    restMonth() {
        if (getValueCookie('TypeUser') === '1') {
            const prev = new Date(this.props.Date.getTime());
            prev.setMonth(prev.getMonth() - 1);
            this.props.Father.changeAllMonthData(this.props.SalesPerson, prev.getTime());
        }
    }


    render() {
        // Get request status
        const { Title = '' } = (this.props || {});
        const { error = '' } = (this.props || {});
        const { loading = '' } = (this.props || {});

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        const isAdmin = getValueCookie('TypeUser') === '1';

        return (
            <>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <h6 className='card-title-clean mb-0'>{Title}</h6>
                            </div>
                            <div className='col-sm-12 pb-2'>
                                <div className='pb-2' />

                                {/* Month banner (2026-09-09 redesign) — same gradient/nav both
                                    roles used to render inside a <th>, now a plain header bar
                                    above the card list; nav arrows only for admins (unchanged
                                    behavior, addMonth/restMonth no-op for non-admins anyway). */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(30, 58, 138) 100%)',
                                    borderRadius: '10px', padding: '8px 10px', marginBottom: '12px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                }}>
                                    {isAdmin && this.props.showMonths === true ? (
                                        <button onClick={() => this.restMonth()} title="Previous month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                            <AiFillCaretLeft />
                                        </button>
                                    ) : <span />}
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem', letterSpacing: '0.5px', textAlign: 'center', flex: 1 }}>{this.props.Month}</span>
                                    {isAdmin && this.props.showMonths === true ? (
                                        <button onClick={() => this.addMonth()} title="Next month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                            <AiFillCaretRight />
                                        </button>
                                    ) : <span />}
                                </div>

                                {/* Vertical-only scroll (2026-09-09 redesign, client's ask —
                                    "el cliente no quiere estar haciendo scroll horizontal").
                                    Each route is a card (name + total up top, the rest of the
                                    metrics in a compact key-value grid below) instead of a
                                    5-column table — nothing to overflow sideways regardless of
                                    how many routes/how long the names get. */}
                                <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: '2px' }}>
                                    {this.props.data.Information.map((element, e) => {
                                        const amount = element.Data[0] || {}
                                        return (
                                            <div key={`route${e}`} className='pol-card' onClick={() => this.getDetail(element.Detail, element.Name)}
                                                style={{ borderLeft: `4px solid ${statusColor(element.Color)}`, padding: '14px 16px', marginBottom: '10px', cursor: 'pointer' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                                    <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>{element.Name}</strong>
                                                    <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(amount.Total))}</strong>
                                                </div>
                                                <div className='pol-card__grid'>
                                                    <div className='pol-kv-box'>
                                                        <span>Percentage</span>
                                                        <strong>{pricesFormat(amount.Percentage)}%</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Goal</span>
                                                        <strong>${NumberFormat(pricesFormat(amount.TotalMeta))}</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Goal Progress</span>
                                                        <strong>{pricesFormat(amount.PercentageComplete)}%</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {this.props.data.Months.map((month, m) => (
                                        <div key={`total${m}`} className='pol-card' style={{ padding: '14px 16px', background: '#F8FAFC' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                                <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>TOTAL</strong>
                                                <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(month.Total))}</strong>
                                            </div>
                                            <div className='pol-card__grid'>
                                                <div className='pol-kv-box'>
                                                    <span>Percentage</span>
                                                    <strong>100%</strong>
                                                </div>
                                                <div className='pol-kv-box'>
                                                    <span>Goal</span>
                                                    <strong>${NumberFormat(pricesFormat(month.TotalMeta))}</strong>
                                                </div>
                                                <div className='pol-kv-box'>
                                                    <span>Goal Progress</span>
                                                    <strong>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Full width now (was col-sm-6, 2026-09-09 redesign, client's ask —
                                "la gráfica... todo sale pequeño y mucho espacio a los lados"):
                                the pie chart had half the row to work with even on a wide screen.
                                Capped at 520px and centered so it doesn't look oversized on very
                                wide monitors, but it's now free to actually use the space. */}
                            <div className='col-sm-12' hidden={this.props.noGraph}>
                                <div className='importantNoteContainer'>
                                    <div className='importantNoteColor'></div>

                                    <p className='importantNoteText'>
                                        The total sales does not include late invoices, spoilage, discounts and credit notes
                                    </p>
                                </div>

                                {this.props.data.Months.map((element, e) => (
                                    <div
                                        key={`t3wrap${e}`}
                                        style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                                    >
                                        <div className='pt-3' style={{ width: '100%', maxWidth: '520px' }} hidden={this.props.noGraph}>
                                            <PieGraph options={element.Options} data={element.DataSet} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
                <DashModalV2
                    title={'Sales: ' + this.state.Title}
                    subtitle={'Total: $' + NumberFormat(pricesFormat(this.state.Total || 0))}
                    show={this.state.showModal1}
                    onClose={() => this.handleModalClose('showModal1')}
                >
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean'>
                            <thead>
                                <tr>
                                    <th>Invoice No</th>
                                    <th>Invoice Type</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Route</th>
                                    <th className='text-end'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Detail.map((order, o) => (
                                    <tr key={'t4tr' + o}>
                                        <td>{order.InvoiceNo}</td>
                                        <td className='text-center'>{order.InvoiceType}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{order.UDF_RUTA}</td>
                                        <td className='text-end'>${NumberFormat(pricesFormat(Number(order.NonTaxableSalesAmt) || 0))}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td className='fw-bold'>Total</td>
                                    <td className='fw-bold'>${NumberFormat(pricesFormat(this.state.Total || 0))}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </DashModalV2>

            </>
        )
    }
}
